import { connect } from "react-redux";

var SkillsetStandardLabel = require("components/writing/questions/SkillsetStandardLabel");

var WritingSelectors = require("lib/selectors/WritingSelectors");

require("writing/controls/analysis_controls.scss");

@connect(
	(state, props) => {
		var downProps = {}

		var answer = WritingSelectors.answer({ state, id: props.answerID });
		var question = WritingSelectors.question({ state, id: answer.question_id })
		var evaluation = WritingSelectors.evaluationForSubject({
			state, subjectType: "Answer", subjectID: props.answerID
		});

		return { answer, question, evaluation };
	}, 
	(dispatch, props) => ({})
)
class AnalysisControls extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	isFillInTheBlank() {
		return this.props.answer.question_type == "fill-in-the-blank-question";
	}

	render() {
		var pasteDetected = _.any((this.props.answer.meta_data || []), (x) => x.paste_detected);

		if (this.props.question && this.props.question.skillset) {
			var skillsetLabel = (
				<p>
					<strong>Question Standard</strong>:
					<SkillsetStandardLabel skillset={ this.props.question.skillset }
						textVariety={ this.props.answer.text_variety } />
				</p>
			);
		}

		return (
			<div className="analysisControls">
				<div className="infoBox">
					{ skillsetLabel }
					<p>
						<strong>Copy/Pasted</strong>: { pasteDetected ? "Yes" : "No" }
					</p>
				</div>
			</div>
		);
	}
};

AnalysisControls.propTypes = StrictPropTypes({
	answerID: PropTypes.number,

	// "enabled" keys used in *this (analysis control)* component (others are ignored)
	// None currently used
	enabled: PropTypes.object,

	// From @connect
	answer: PropTypes.object,
	question: PropTypes.object,
	evaluation: PropTypes.object
});

module.exports = AnalysisControls;



// WEBPACK FOOTER //
// ./modules/components/writing/controls/AnalysisControls.js